var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-32 px-20 flex gap-20"},[_c('filter-button'),_vm._v(" "),_c('sort-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }